export default async function () {
  const attrs = await useSekouAttr();

  const planAttrs = computed(() => {
    // 1: スタイル
    // 2: デザイン
    // 3: リフォーム
    // 6: エクステリア
    return attrs.value.filter((attr) => [1, 2, 3, 6].includes(attr.category));
  });

  return planAttrs;
}
